import { Injectable } from '@angular/core';

@Injectable()
export class ProjectOrganizationalSnapshotValidations {


  constructor() { }



  public loadOrganizationalSnapshotData(model: any) {
    //Limpiamos los datos de la pantalla
    model.dto.projectOrganizationalSnapshot.contractorOrganizationalUnitName = undefined;
    model.dto.projectOrganizationalSnapshot.contractorOrganizationalUnitHex = undefined;
    model.dto.projectOrganizationalSnapshot.fundsCenterDescription = undefined;
    model.dto.projectOrganizationalSnapshot.fundsCenter = undefined;
    model.dto.projectOrganizationalSnapshot.promoterOrganizationalUnitName = undefined;
    model.dto.projectOrganizationalSnapshot.promoterOrganizationalUnitHex = undefined;
    model.dto.projectOrganizationalSnapshot.contractorInboxName = undefined;
    model.dto.projectOrganizationalSnapshot.contractorInboxId = undefined;

    //Si hemos seleccionado valor en el combo. Si no tiene valor viene con undefined o con null....¿?¿?
    if (model.dto.previousOrganizationalUnitRegistration !== undefined && model.dto.previousOrganizationalUnitRegistration !== null) {
      if (model.dto.previousOrganizationalUnitRegistration) {
        //Se ha seleccionado SI. Comprobamos si tiene cargado el origen (ya viene de servidor con todo ok). Si no, no cargamos nada, tienen que buscarlo.
        if (model.dto.originProjectOrganizationalSnapshot !== undefined) {
          model.dto.projectOrganizationalSnapshot = JSON.parse(JSON.stringify(model.dto.originProjectOrganizationalSnapshot));
        }
      } else {
        //Se ha seleccinado NO. Cargamos el ultimo destino. Ya viene de servidor con todo ok.
        model.dto.projectOrganizationalSnapshot = JSON.parse(JSON.stringify(model.dto.lastDestinationProjectOrganizationalSnapshot));;
      }
      model.ui.selectedProjectOrganizationalSnapshot = model.dto.projectOrganizationalSnapshot;
    }
  }

  //Se ha seleccionado el hito desde el buscador porque existe mas de un origen
  public changeProjectOrganizationalSnapshot(model: any) {
    if (model.ui.selectedProjectOrganizationalSnapshot) {
      model.dto.projectOrganizationalSnapshot.promoterOrganizationalUnitName = model.ui.selectedProjectOrganizationalSnapshot.content.UD_PROMOTORA_DESCRIP.value;
      model.dto.projectOrganizationalSnapshot.promoterOrganizationalUnitHex = model.ui.selectedProjectOrganizationalSnapshot.content.UD_PROMOTORA_ID.value;
      model.dto.projectOrganizationalSnapshot.contractorOrganizationalUnitName = model.ui.selectedProjectOrganizationalSnapshot.content.UD_CONTRATADORA_DESCRIP.value;
      model.dto.projectOrganizationalSnapshot.contractorOrganizationalUnitHex = model.ui.selectedProjectOrganizationalSnapshot.content.UD_CONTRATADORA_ID.value;
      model.dto.projectOrganizationalSnapshot.fundsCenterDescription = model.ui.selectedProjectOrganizationalSnapshot.content.CENTRO_GESTOR_DESCRIP.value;
      model.dto.projectOrganizationalSnapshot.fundsCenter = model.ui.selectedProjectOrganizationalSnapshot.content.CENTRO_GESTOR_ID.value;
      model.dto.projectOrganizationalSnapshot.contractorInboxName = model.ui.selectedProjectOrganizationalSnapshot.content.ORG_CONTRATACION_DESCRIP.value;
      model.dto.projectOrganizationalSnapshot.contractorInboxId = model.ui.selectedProjectOrganizationalSnapshot.content.ORG_CONTRATACION_ID.value;
    } else {
      //La unidad promotora no tiene valor.
      model.dto.projectOrganizationalSnapshot.contractorOrganizationalUnitName = undefined;
      model.dto.projectOrganizationalSnapshot.contractorOrganizationalUnitHex = undefined;
      model.dto.projectOrganizationalSnapshot.fundsCenterDescription = undefined;
      model.dto.projectOrganizationalSnapshot.fundsCenter = undefined;
      model.dto.projectOrganizationalSnapshot.promoterOrganizationalUnitName = undefined;
      model.dto.projectOrganizationalSnapshot.promoterOrganizationalUnitHex = undefined;
      model.dto.projectOrganizationalSnapshot.contractorInboxName = undefined;
      model.dto.projectOrganizationalSnapshot.contractorInboxId = undefined;
    }
  }

  public visiblePreviousOrganizationalUnitRegistration(model: any) {
    let activeTemporayPeriodOrganizationalChange = model.ui.activeTemporayPeriodOrganizationalChange;
    return activeTemporayPeriodOrganizationalChange || (!activeTemporayPeriodOrganizationalChange && model.dto.previousOrganizationalUnitRegistration !== undefined);
  }




}